<template v-if="widget.type==='info'">
  <v-card :width="widget.data.width" :style="widget.data.color==='primary' ? 'background-color: #0575e6; background-image: linear-gradient(to right, #0575e6, #021b79)' : widget.data.color==='warning' ? 'background-color: #fdc830; background-image: linear-gradient(to right, #fdc830, #f37335)' : widget.data.color==='success' ? 'background: linear-gradient(to right, #34e89e, #0f3443)' : widget.data.color==='error' ? 'background-color: #eb5757; background-image: linear-gradient(to right, #eb5757, #000000)' : 'background:' + widget.data.color + ';'+widget.data.customStyle" dark>
    <v-card-title class="text-h5" v-if="widget.data.title!==''">
      {{ widget.data.title }}
    </v-card-title>
    <v-card-actions class="pr-2 pl-2">
      <v-container style="padding-top: 0 ; padding-bottom: 0">
        <v-row  style="padding-top: 0 ; padding-bottom: 0 ; margin-top: 0" v-for="item in widget.data.items" :key="item.key">
          <v-col class="fontSizeInfo pa-3 pb-3" :style="'line-height: 26px !important;text-align:'+widget.data.alignItems + ';font-size: '+widget.data.fontSizeItems+' !important; color:  '+widget.data.textColor+'!important ; '">
            {{ item.value }}
          </v-col>
        </v-row>
      </v-container>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "info-card",
  props : {
    widget : Object
  }
}
</script>

<style scoped>
.fontSizeInfo{
  font-size: 12px !important;
}
.v-card .v-card__subtitle:last-child, .v-card .v-card__text:last-child, .v-card .v-card__actions:last-child {
  padding-bottom: 17px !important;
}
.v-card > .v-card__subtitle:first-child, .v-card > .v-card__text:first-child, .v-card > .v-card__actions:first-child {
  padding-top: 5px !important;
}
</style>
